'use client';

import { onlineManager } from '@tanstack/react-query';
import { createContext, useContext, useSyncExternalStore } from 'react';

type OnlineContextValue = { isOnline: boolean };

const OnlineContext = createContext<OnlineContextValue>({ isOnline: true });

function subscribe(onStoreChange: () => void) {
  return onlineManager.subscribe(onStoreChange);
}

function getSnapshot(): boolean {
  return onlineManager.isOnline();
}

function getServerSnapshot(): boolean {
  return true;
}

export function OnlineProvider({ children }: { children: React.ReactNode }) {
  const isOnline = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return <OnlineContext.Provider value={{ isOnline }}>{children}</OnlineContext.Provider>;
}

export function useOnline(): OnlineContextValue {
  return useContext(OnlineContext);
}
